<div class="container">
  <div class="content">
    <div class="title">
      <div class="back" (click)="back()">
        <img
          src="../../../../assets/images/help/Icon-back.svg"
          [width]="30"
          [height]="30"
          alt=""
        />返回
      </div>
    </div>
    <div class="detail">
      <div class="select">
        <div class="theme">问题类别</div>
        <div class="categories">
          <div
            class="categorie"
            *ngFor="let item of categories"
            [ngClass]="{ active: item.id === id }"
            (click)="gotoTag(item.id)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <mat-spinner *ngIf="loading" [diameter]="60"></mat-spinner>
      <div class="cards">
        <ng-container *ngIf="!loading">
          <div
            class="card"
            *ngFor="let item of cards"
            [routerLink]="
              '/helping/detail/' +
              this.id +
              '/p/' +
              page +
              '/article/' +
              item.id
            "
          >
            <div class="card-title">
              {{ item.title }}
            </div>
            <div class="card-content" [innerHTML]="item.content"></div>
          </div>
        </ng-container>
        <mat-paginator
          [length]="total"
          [pageSize]="pageSize"
          [pageIndex]="page"
          (page)="onPageChange($event)"
        ></mat-paginator>
      </div>
    </div>
  </div>
</div>
